import React from 'react';
import { connect } from 'react-redux';
import Catalog from './catalog/category/list';
import Orders from './orders';
import Messages from './messages';
import Sandbox from './sandbox';

const Content = props => {
  const { mainScreenPage } = props;
  const style = {
    display: 'flex',
    flex: '1 0 auto'
  }
  return (
    <div style={style}>
      { mainScreenPage === 'catalog' &&
        <div style={{display: 'flex', justifyContent: 'center', flex: '1'}}>
          <Catalog />
        </div>
      }
      { mainScreenPage === 'orders' && <Orders />}
      { mainScreenPage === 'messages' && <Messages />}
      { mainScreenPage === 'sandbox' && <Sandbox />}
    </div>
  );
}

export default connect(
  state => ({ mainScreenPage: state.ui.mainScreenPage })
)(Content);



// WEBPACK FOOTER //
// ./src/components/layout/content/index.js